module.exports = __webpack_public_path__ + "static/media/CryptoDemo.e4c82890.jpg";